import {
  ActionButton,
  Badge,
  CalendarHeader,
  Paginator,
  Show,
  TableComponent,
} from "components";
import { usePagination } from "hooks";
import { useBatchReports } from "hooks/data/use-batch-reports";
import moment from "moment";

type Props = {};

const BatchReportingPage = () => {
  const { offset, limit, setPage, fromDate, toDate } = usePagination();
  const { batchReports, count, loading, refetch } = useBatchReports({
    filter: {
      date_from: moment(fromDate).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      date_to: moment(toDate).endOf("day").format("YYYY-MM-DD HH:mm:ss"),
    },
    pagination: {
      limit: limit,
      offset: offset,
    },
  });


  return (
    <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
      <CalendarHeader />
      <div className="flex flex-1 overflow-y-auto">
        <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
          <TableComponent
            loading={loading}
            title={"batched reports"}
            hasSearch
            columns={[
              {
                name: "Report #",
                accessor: "report_id",
                render: (value) => (
                  <span className={`text-${value?.status?.toLowerCase()}`}>#{value?.report_id}</span>
                )
              },
              {
                name: "Report Type",
                accessor: "description",
                render: (value) => (
                  <span>{value?.description || "N/A"}</span>
                )
              },
              {
                name: "Status",
                accessor: "status",
                render: (value) => (
                  <Badge status={value?.status === "COMPLETED" ? "success" : value?.status === "FAILED" ? "error" : "neutral"} label={value?.status} />
                )
              },
              {
                name: "Created At",
                accessor: "created_at",
                render: (value) => (
                  <span>{moment(value?.created_at).format("DD/MM/YYYY HH:mm A")}</span>
                )
              },
              {
                name: "Created By",
                accessor: "employee.employee_first_name",
              },
              {
                name: "Actions",
                accessor: "actions",
                render: (value) => (
                  <>
                    <Show if={value?.status === "COMPLETED"}>
                      <ActionButton
                        action={"download"}
                        tooltip="Download Report"
                        onClick={() => {
                          window.open(value?.downloadable_pdf_link || "", "_blank");
                        }}
                      />
                    </Show>
                    <Show if={value?.status === "COMPLETED"}>
                      <ActionButton
                        action={"sheet-report"}
                        tooltip="Download Report Sheet"
                        onClick={() => {
                          window.open(value?.downloadable_xlsx_link || "", "_blank");
                        }}
                      />
                    </Show>

                  </>
                ),
              },
            ]}
            data={batchReports}
            refetch={refetch}
            pagination={() => (
              <Paginator
                offset={offset}
                limit={limit}
                totalItems={count}
                currentSize={batchReports.length}
                setOffset={setPage}
              />
            )}
          />
        </div>
      </div>
    </main>
  );
};

export default BatchReportingPage;
